import React, { useEffect, useState } from "react";

import {
    Edit,
    FileField,
    FileInput,
    Loading,
    SimpleForm,
    TextInput,
    SelectInput,
    useEditContext
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import BackButton from "./BackButton";
import { 
    useParams, 
} from 'react-router-dom';
import { supabaseClient } from './supabase';

const DisciplineEdit = (props) => {
    const [signedUrl, setSignedUrl] = useState(null);
    const [tempDiscipline, setTempDiscipline] = useState(null);
    const [theDiscipline, setTheDiscipline] = useState(null);
    const { id } = useParams();

    const grades = [
        { id: 0, name: 'Grade R' },
        { id: 1, name: 'Grade 1' },
        { id: 2, name: 'Grade 2' },
        { id: 3, name: 'Grade 3' },
        { id: 4, name: 'Grade 4' },
        { id: 5, name: 'Grade 5' },
        { id: 6, name: 'Grade 6' },
        { id: 7, name: 'Grade 7' },
    ];

    const getSignedUrl = async (file) => {
        if (file) {
            console.log(`Passed in file prop inside getSignedURL: ${file}`);
            try {
                const { data: media, error: mediaError } = await supabaseClient.storage
                    .from('media')
                    .createSignedUrl(`${file}`, 3600, {download: `${file}`});
                if (mediaError) throw new Error(mediaError.message);
                setSignedUrl(media.signedUrl);
            } catch (err) {
                console.log(`Caught error inside getSignedURL: ${err.message}`);
                setSignedUrl('');
            }
        } else {
            setSignedUrl('');
        }
    }

    const getDiscipline = async (id) => {
        const { data: record, error } = await supabaseClient
            .from("discipline")
            .select(`
                id,
                grade,
                title,
                description,
                file,
                type
            `)
            .match({ id: id}).single();
        if (error) throw new Error(`Error fetching the records: ${error.message}`);
        console.log(`record inside getDiscipline: ${JSON.stringify(record)}`);
        setTempDiscipline(record);
    }

    useEffect(() => {
        console.log(`id inside useEffect: ${id}`);
        getDiscipline(id);
    }, [id]);

    useEffect(() => {
        if (tempDiscipline) {
            getSignedUrl(tempDiscipline.file);            
        }
    }, [tempDiscipline]);

    useEffect(() => {
        if (tempDiscipline !== null) {
            setTheDiscipline({
                ...tempDiscipline,
                media: {
                    title: tempDiscipline.file,
                    src: signedUrl
                }
            });
        }
    }, [signedUrl, tempDiscipline]);

    console.log(`theDiscipline outside useEffect(): ${JSON.stringify(theDiscipline)}`);
    console.log(`signedUrl: ${signedUrl}`);
    
    return theDiscipline && (
        <Edit resource="discipline" id={theDiscipline.id} {...props} title="Edit discipline record">
            <SimpleForm record={theDiscipline}>
                <SelectInput source="grade" choices={grades} />
                <TextInput source="title" />
                <RichTextInput source="description" />
                <FileInput source="media" multiple={false}>
                    <FileField source="src" title="title" />
                </FileInput>
            </SimpleForm>
            <BackButton />
        </Edit>
    )
};

export default DisciplineEdit;
